import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminDeleted_itemsInvoices = z.any()
export type TagsGetAdminDeleted_itemsInvoices = z.infer<typeof tagsGetAdminDeleted_itemsInvoices>

export const responseGetAdminDeleted_itemsInvoices = z.object({ "payload": z.array(z.object({ "id": z.string(), "identifier": z.string(), "periodFrom": z.string().datetime({ offset: true }).optional(), "periodTo": z.string().datetime({ offset: true }).optional(), "collectionPoint": z.object({ "name": z.string() }), "building": z.object({ "name": z.string() }), "municipality": z.object({ "name": z.string() }), "deletedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminDeleted_itemsInvoices = z.infer<typeof responseGetAdminDeleted_itemsInvoices>

interface IGetAdminDeleted_itemsInvoices extends BaseMethodType {
  tags: TagsGetAdminDeleted_itemsInvoices,
  response: ResponseGetAdminDeleted_itemsInvoices
}
export const URL = '/admin/deleted-items/invoices'
export const validation = {
  get: {
    tags: tagsGetAdminDeleted_itemsInvoices,
    response: responseGetAdminDeleted_itemsInvoices
  }
}
export interface AdminDeleted_itemsInvoices extends BaseRouteType {
  get: IGetAdminDeleted_itemsInvoices
}